import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-earn-page',
  templateUrl: './earn-page.component.html',
  styleUrls: ['./earn-page.component.scss'],
})
export class EarnPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
